<!-- aqui definimos las ordenes superiores y a que division pertenece -->
 <template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Registro de Orden de Operacion Armada Boliviana</h4>        
                <hr>
                <p>  {{ title_page | capitalize }}</p>
            </div>
        </div>
    </div>
    
    <nav>
        <div class="nav nav-pills" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">Registro de Orden Operacion</a>
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-init-modify" role="tab" aria-controls="nav-home" aria-selected="true">Operaciones Activas </a>
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-old" role="tab" aria-controls="nav-home" aria-selected="true">Bitacora de Operaciones </a>
        </div>
    </nav>
    
    <!-- aqui va el cuerpo -->
    <div class="tab-content" id="nav-tabContent">
        <br>            
        <div class="tab-pane fade show active" id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">     
            <h6>REGISTRO DE OPERACIONES PRINCIPALES</h6>
            <div class="form-row">
                <div class="form-group col-12 col-md-6" v-if="is_administrador">
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <select name="division_master" class="form-control" id="division_master" v-model="division_select">
                        <option v-for="divl in list_divisiones" :value="divl" :key="divl.id">{{divl.short_detail}}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-6" v-else>
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <input type="text" v-model="division_select.short_detail" class="form-control-plaintext" id="ordop_title"  autocomplete="off">
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="ordop_title">Titulo ORDOP Principal <span class="required-text">*</span></label>
                    <input type="text" v-model="ordop_superior.titulo" class="form-control" id="ordop_title" placeholder="BALA"  autocomplete="off">
                </div>
            </div>
            
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="date_init_ordop">Fecha Inicio <span class="required-text">*</span></label>
                    <datetime v-model="ordop_superior.inicio" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="date_init_ordop">Fecha Conclusion <span class="required-text">*</span></label>
                    <datetime v-model="ordop_superior.final" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                </div>
            </div>
            
            <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="btn_r_ordop_master" @click="mSaveOrdopMaster">
                    <font-awesome-icon icon="save" size="3x" />
            </button>
            
        </div>
        <!-- end fisrt tab -->
        
        <div class="tab-pane fade" id="nav-init-modify" role="tabpanel" aria-labelledby="nav-home-tab">     
            <h6>LISTADO DE OPERACIONES ACTIVAS</h6>
            
            <div class="form-row">
                <div class="form-group col-12 col-md-6 offset-md-3" v-if="is_administrador">
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <select name="division_master" class="form-control" id="division_master" v-model="division_select">
                        <option v-for="divl in list_divisiones" :value="divl" :key="divl.id">{{divl.short_detail}}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-6 offset-md-3" v-else>
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <input type="text" v-model="division_select.short_detail" class="form-control-plaintext" id="ordop_title"  autocomplete="off">
                </div>                
                
            </div>
            
            <button class="btn btn-outline-success col-12 col-md-4 offset-md-4" @click="mLlamaOrdopsMasterVigentes"><font-awesome-icon icon="list" size="3x" />Listar</button>
            <br><br>
            <div class="table-responsive" v-if="list_ordops_actives.length>0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>División</th>
                            <th>Titulo</th>
                            <th>Inicio</th>
                            <th>Final</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(loa,index) in list_ordops_actives" :key="loa.id">
                            <td>{{ (index+1) }}</td>
                            <td>{{ loa.descripcion_division }}</td>
                            <td>{{ loa.titulo_superior }}</td>
                            <td>{{ $dateWrite(loa.inicio) }}</td>
                            <td>{{ $dateWrite(loa.final) }}</td>
                            <td align="center">
                                <button class="btn btn-success" v-if="loa.estado==='A'" @click="mChangeState(loa.id, index)"><font-awesome-icon icon="toggle-on" size="lg" /></button>
                                <button class="btn btn-danger" v-else @click="mChangeState(loa.id, index)"><font-awesome-icon icon="toggle-off" size="lg" /></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
        
        <div class="tab-pane fade" id="nav-old" role="tabpanel" aria-labelledby="nav-home-tab">
            <h6>LISTADO DE OPERACIONES EN RANGO DE FECHAS</h6>
            
            <div class="form-row">
                <div class="form-group col-12 col-md-6 offset-md-3" v-if="is_administrador">
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <select name="division_master" class="form-control" id="division_master" v-model="division_select">
                        <option v-for="divl in list_divisiones" :value="divl" :key="divl.id">{{divl.short_detail}}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-6 offset-md-3" v-else>
                    <label for="division_master">División <span class="required-text">*</span></label>
                    <input type="text" v-model="division_select.short_detail" class="form-control-plaintext" id="ordop_title" placeholder="BALA"  autocomplete="off">
                </div>                
                
            </div>
            <hr>
            <h5>Seleccione el rango de fechas para listar de las Ordops Registradas</h5>
            <div class="form-row">
                <div class="form-group col-12 col-md-6">
                    <label for="date_init_ordop">Fecha Inicio <span class="required-text">*</span></label>
                    <datetime v-model="ordop_superior_historico.inicio" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                </div>
                <div class="form-group col-12 col-md-6">
                    <label for="date_init_ordop">Fecha Conclusion <span class="required-text">*</span></label>
                    <datetime v-model="ordop_superior_historico.final" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                </div>
            </div>
            <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mLlamaOrdopsMasterVigentesHistorico"> <font-awesome-icon icon="list" size="3x" /> Listar</button>
            
            
            <br><br>
            <div class="table-responsive" v-if="list_ordops_actives_historico.length>0">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>División</th>
                            <th>Titulo</th>
                            <th>Inicio</th>
                            <th>Final</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(loa,index) in list_ordops_actives_historico" :key="loa.id">
                            <td>{{ (index+1) }}</td>
                            <td>{{ loa.descripcion_division }}</td>
                            <td>{{ loa.titulo_superior }}</td>
                            <td>{{ $dateWrite(loa.inicio) }}</td>
                            <td>{{ $dateWrite(loa.final) }}</td>
                            <td align="center">
                                <button class="btn btn-success" v-if="loa.estado==='A'" @click="mChangeStateHistorico(loa.id, index)"><font-awesome-icon icon="toggle-on" size="lg" /></button>
                                <button class="btn btn-danger" v-else @click="mChangeStateHistorico(loa.id, index)"><font-awesome-icon icon="toggle-off" size="lg" /></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
        
    </div>
    
    
</div>
 </template>
 
 <script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

 export default {
    mounted(){
        this.mChargeInit();
    },
    methods:{
        async mChangeStateHistorico(idp, idx){
            let nstate;
            try {
                if(this.list_ordops_actives_historico[idx].estado==='A'){
                    // this.list_ordops_actives_historico[idx].estado='F';
                    nstate='F';
                }else{
                    // this.list_ordops_actives_historico[idx].estado='A';
                    nstate='A';
                }
                let sordop={
                    id_ordop:idp,
                    init:nstate
                }
                let ns=await axios.post(`updateStatusOrdopHistorico?api_token=${Vue.auth.getToken()}`, qs.stringify(sordop));    
                if(ns.data.status){
                    toastr.success(`${ns.data.respuesta}`, 'Exito');
                    this.list_ordops_actives_historico[idx].estado=nstate;
                    
                }else{
                    toastr.error(`${ns.data.respuesta}`, 'Error')
                }
            } catch (error) {
                console.log(error)
            }
        },
        async mChangeState(idp, idx){
            let nstate;
            try {
                
                let sordop={
                    id_ordop:idp,
                    init:'F'
                }
                let ns=await axios.post(`updateStatusOrdopMaster?api_token=${Vue.auth.getToken()}`, qs.stringify(sordop));    
                
                if(ns.data.status){
                    toastr.success(`${ns.data.respuesta}`, 'Exito')
                }else{
                    toastr.error(`${ns.data.respuesta}`, 'Error')
                }
                
                if(this.list_ordops_actives[idx].estado==='A'){
                    // this.list_ordops_actives[idx].estado='F';
                    // nstate='N';
                    this.list_ordops_actives.splice(idx,1);
                }
                
                
            } catch (error) {
                console.log(error)
            }
        },
        mValidaFechasHistorico(){
            let adi=this.ordop_superior_historico.inicio.split('T');
            this.ordop_superior_historico.inicio=adi[0];

            if( this.ordop_superior_historico.inicio === null || !(this.ordop_superior_historico.inicio.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            
            let adf=this.ordop_superior_historico.final.split('T');
            this.ordop_superior_historico.final=adf[0];

            if( this.ordop_superior_historico.final === null || !(this.ordop_superior_historico.final.length === 10) ){
                toastr.error('La fecha de Conclusion es incorrecta', 'Error');
                return false;
            }
            return true;  
        },
        async mLlamaOrdopsMasterVigentesHistorico(){
            
            
            this.list_ordops_actives_historico=[];
            if(this.division_select.id!==0 && this.mValidaFechasHistorico()){
                let listActivos=await axios.get(`listOrdopMaster/${this.division_select.id}/T/${this.ordop_superior_historico.inicio}/${this.ordop_superior_historico.final}?api_token=${Vue.auth.getToken()}`);
                console.log(listActivos);
                if(listActivos.data.length>0){
                    // toastr.success(`Se ha encontrado ${listActivos.data.length} Activos`);
                    this.list_ordops_actives_historico=listActivos.data;
                }else{
                    toastr.warning(`No se ha encontrado registros Activos`);
                }
            }else{
                toastr.warning(`Seleccione una division para su consulta o revise las fechas`);
            }
        },
        async mLlamaOrdopsMasterVigentes(){
            this.list_ordops_actives=[];
            if(this.division_select.id!==0){
                let listActivos=await axios.get(`listOrdopMaster/${this.division_select.id}/A/0/0?api_token=${Vue.auth.getToken()}`);
                console.log(listActivos);
                if(listActivos.data.length>0){
                    toastr.success(`Se ha encontrado ${listActivos.data.length} Activos`);
                    this.list_ordops_actives=listActivos.data;
                }else{
                    toastr.warning(`No se ha encontrado registros Activos`);
                }
            }else{
                toastr.warning(`Seleccione una division para su consulta`);
            }
        },
        mValidateOrdopPrincipal(){
            if(this.division_select.id===0){
                toastr.warning(`Seleccione una Division a la cual se registrara la Orden de Operacion`);
                return false;
            }
            if(this.ordop_superior.titulo==='' || this.ordop_superior.titulo.trim()===''){
                toastr.warning(`Seleccione una Division a la cual se registrara la Orden de Operacion`);
                return false;
            }
            
            let adi=this.ordop_superior.inicio.split('T');
            this.ordop_superior.inicio=adi[0];

            if( this.ordop_superior.inicio === null || !(this.ordop_superior.inicio.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            
            let adf=this.ordop_superior.final.split('T');
            this.ordop_superior.final=adf[0];

            if( this.ordop_superior.final === null || !(this.ordop_superior.final.length === 10) ){
                toastr.error('La fecha de Conclusion es incorrecta', 'Error');
                return false;
            }
            return true;
        },        
        async mSaveOrdopMaster(){
            console.log('enviando el registro principal de las ORDOPS')
            
            let message = {
                title: 'Orden de Operacion',
                body: `¿Desea Registrar la Orden de operacion de la ${this.division_select.short_detail} que lleva por titulo <b>${this.ordop_superior.titulo}</b>?`
            };
            // validar que los datos esten completos

            if(this.mValidateOrdopPrincipal()){
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.ordop_superior.division_id=this.division_select.id;
                            this.ordop_superior.division_detail=this.division_select.short_detail;
                            
                            this.btn_r_ordop_master = true;
                            // this.activeModal(this.id_modal_progress);
                            let s_dts_ordop_master=await axios.post(`registerOrdopMaster?api_token=${Vue.auth.getToken()}`, qs.stringify(this.ordop_superior));

                            setTimeout(()=>{                                
                                if(s_dts_ordop_master.data.status){
                                    toastr.success(s_dts_ordop_master.data.respuesta);
                                    this.ordop_superior.titulo='';
                                    this.btn_r_ordop_master = false;
                                    
                                }else{
                                    toastr.warning(s_dts_ordop.data.respuesta);
                                    this.btn_r_ordop_master = false;    
                                }                               
                                this.inactiveModal(this.id_modal_progress);
                            },2000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                // this.inactiveModal(this.id_modal_progress);
                                this.btn_r_ordop_master = false;
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }
            
        },
        async mChargeInit(){
            let calldivisiones = await axios.get(`globals/divisiones?api_token=${Vue.auth.getToken()}`);
            this.list_divisiones=calldivisiones.data;
            setTimeout(() => {
                switch(this.cDtsUser.roleAssign){
                    case 'DIVISION BRAVO':
                        this.title_page='DIVISION BRAVO'
                        console.log(calldivisiones.data);
                        let idxb=calldivisiones.data.findIndex((dt)=>dt.short_detail==='DIV. "B"');
                        console.log(idxb);
                        this.division_select.id=calldivisiones.data[idxb].id;
                        this.division_select.detail=calldivisiones.data[idxb].detail;
                        this.division_select.short_detail=calldivisiones.data[idxb].short_detail;
                        this.is_administrador=false;
                    break;
                    
                    case 'DIVISION DELTA':
                        this.title_page='DIVISION DELTA'
                        let idxd=calldivisiones.data.findIndex((dt)=>dt.short_detail==='DIV. "D"');
                        this.division_select.id=calldivisiones.data[idxd].id;
                        this.division_select.detail=calldivisiones.data[idxd].detail;
                        this.division_select.short_detail=calldivisiones.data[idxd].short_detail;
                        this.is_administrador=false;
                    break;
                    
                    default:
                        this.title_page='ADMINISTRADOR'
                        this.is_administrador=true;                    
                    break;
                }    
            }, 700);
            
        }  
    },
    data(){
        return {
            title_page:'',
            list_divisiones:[],
            division_select:{id:0},
            is_administrador:false,
            ordop_superior:{
                titulo:'',
                inicio:'',
                final:'',
                division_id:0,
                division_detail:''
            },
            ordop_superior_historico:{
                inicio:'',
                final:''
            },
            ordop_superior_edit:{
                id:0,
                titulo:'',
                inicio:'',
                final:'',
                estado:''                
            },
            btn_r_ordop_master:false,
            list_ordops_actives:[],
            list_ordops_actives_historico:[]
        }
    },
    computed:{
        cHoraMilitaryEdit(){
            // return this.$dateMilitary(this.dts_ordop.date_init, this.dts_ordop.time_init);
            try {
                let auxTime=this.dts_ordop_edit.date_init.split('T');
                let ah=this.time_init_aux_edit.split('T');
                let ah2=ah[1].split(':');
                
                return this.$dateMilitary(auxTime[0], `${ah2[0]}:${ah2[1]}`);
            } catch (error) {
                console.log(error);
            }
        },
        cHoraMilitaryInit(){
            // return this.$dateMilitary(this.dts_ordop.date_init, this.dts_ordop.time_init);
            try {
                let auxTime=this.dts_ordop.date_init.split('T');
                let ah=this.time_init_aux.split('T');
                let ah2=ah[1].split(':');
                
                return this.$dateMilitary(auxTime[0], `${ah2[0]}:${ah2[1]}`);
            } catch (error) {
                console.log(error);
            }
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
 }
 </script>
 
 <style>
 
 </style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopMaster.vue